import { IPanelProps, IRenderFunction, Panel, PanelType } from "@fluentui/react";
import React, { CSSProperties, ReactNode } from "react";
interface PanelProps {
  isOpen: boolean;
  headerText?: string
  onDismiss?: (ev?: React.SyntheticEvent<HTMLElement> | KeyboardEvent) => void;
  type?: PanelType
  customWidth?: string
  content?: ReactNode;
  className?: string;
  isFooterAtBottom?: boolean
  isBlocking?: boolean
  onRenderFooterContent?: IRenderFunction<IPanelProps>
  contentStyle?: any,
  hasCloseButton?: boolean,
  styles?: any
}

const SamplePanel = (props: PanelProps) => {
  const { contentStyle = {}, hasCloseButton = true, styles = {} } = props;
  return (
    <>
      <Panel
        isLightDismiss
        className={props.className}
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        type={props.type}
        customWidth={props.type === PanelType.custom || props.type === PanelType.customNear ? props.customWidth : undefined}
        closeButtonAriaLabel="Close"
        headerText={props.headerText}
        isFooterAtBottom={props.isFooterAtBottom}
        isBlocking={props.isBlocking}
        onRenderFooterContent={props.onRenderFooterContent}
        hasCloseButton={hasCloseButton}
        styles={{
          overlay: {
            background: "#0000001A"
          },
          content: {
            position: "relative",
            zIndex: 2,
            overflowX: "hidden",
            overflowY: "auto",
            height: "100vh",
            ...contentStyle
          },
          footer: {
            borderTop: "1px solid #EDEBE9"
          },
          ...(styles || {})
        }}
      >
        {props.content}
      </Panel>
    </>
  );
};

export default SamplePanel;
